import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/paper_status', component: List, name: 'paper_status.index'},
  {path: '/paper_status/store', component: Form, name: 'paper_status.store'},
  {path: '/paper_status/:id', component: Form, name: 'paper_status.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/paper_status/routes.js